export default __webpack_public_path__ + "static/media/pixel.e887166a.png";